<template>
  <div class="page-questionnaire">
    <div class="content">
      <div class="header">
        <h2 class="title">
          {{ questionnairePlanInfo.name }}
        </h2>
        <div class="patient-info">
          <span>
            {{patientInfo.name}} {{ { '1': '男', '2': '女' }[patientInfo.sex] }} {{patientInfo.age}}岁
          </span>
        </div>
      </div>
      <div class="question-list">
        <div class="question-item" 
          v-for="(question, index) in (mode === 'edit' ? questionnaireAnswer.questionList : questionnaireDetailsDTO.questionList)"
          :key="question.id">
          <span class="question-title" :class="{'required': question.isRequired}">
            {{index + 1}}. {{question.title}}
          </span>
          <div v-if="question.type === 4 && question.contentVerifyType === 0" class="answer-area">
            <van-field placeholder="请输入" v-model="question.answer" :maxlength="30"></van-field>
          </div>
          <div v-if="question.type === 4 && question.contentVerifyType === 2" class="answer-area">
            <van-field placeholder="请输入" type="number" v-model="question.answer" :maxlength="30"></van-field>
          </div>
          <div v-if="question.type === 4 && question.contentVerifyType === 1" class="answer-area">
            <van-field placeholder="请选择" readonly @click="question.showPicker=true" :value="question.answer"></van-field>
            <van-popup get-container="body" v-model="question.showPicker" position="bottom">
              <van-datetime-picker
                type="date"
                title="选择年月日"
                @cancel="question.showPicker=false"
                :min-date="minDate"
                :max-date="maxDate"
                v-model="question.tempDate"
                @confirm="selectDate($event, question)"
              />
            </van-popup>
          </div>
          <div v-if="question.type === 1" class="answer-area">
            <van-radio-group v-model="question.answer">
              <van-radio :name="option.optionsRelationId" v-for="option in question.optionList" :key="option.optionsRelationId">{{option.option}}</van-radio>
            </van-radio-group>
          </div>
          <div v-if="question.type === 2" class="answer-area">
            <van-checkbox-group v-model="question.answer">
              <van-checkbox :name="option.optionsRelationId" v-for="option in question.optionList" :key="option.optionsRelationId" shape="square">{{option.option}}</van-checkbox>
            </van-checkbox-group>
          </div>
          <div v-if="question.type === 8" class="answer-area">
            <van-uploader
              accept="image/*"
              :after-read="afterRead"
              :class="['preview-images',  { 'app-upload': env.inAPP }]"
              v-model="question.answer"
              :max-count="6"
            >
              <div class="upload-preview-wrap">
                <div class="upload-preview">
                  <icon-font class="icon-right" icon-name="tianjia" />
                </div>
              </div>
            </van-uploader>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <van-button @click="onSave" type="default" style="margin-right: 10px">保存草稿</van-button>
      <van-button @click="submit" type="primary">提交</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { env } from '@zyf2e/adapt';
import iconFont from '@/components/iconFont.vue';
import { DatetimePicker } from '@zyf2e/capui-mobile';

Vue.use(DatetimePicker);

export default {
  name: "page-questionnaire",
  components: {
    iconFont
  },
  data() {
    return {
      header: {
        title: '问卷',
        rightText: '保存草稿'
      },
      type: 1,
      showPicker: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      checked: '2',
      checkedList: ['b'],
      fileList: [],
      imgUploading: false,
      curDate: null,
      businessCode: '',
      mode: '',
      patientInfo: {},
      questionnaireDetailsDTO: { questionList: [] },
      questionnairePlanInfo: {},
      questionnaireAnswer: { questionList: [] },
      env,
      answerChange: false
    }
  },
  mounted() {
    const { code } = this.$route.query; 
    this.businessCode = code;
    this.initQuestionnaire(code);
  },
  computed: {
    questionList() {
      if(this.mode === 'edit') {
        return this.questionnaireAnswer.questionList || [];
      } else {
        return this.questionnaireDetailsDTO.questionList || [];
      }
    }
  },
  watch: {
    questionList: {
      deep: true,
      handler(newVal, oldVal) {
        if (Array.isArray(oldVal) && oldVal.length > 0) {
          this.answerChange = true;
        }
      }
    }
  },
  methods: {
    async initQuestionnaire(code) {
      const { data: { patientInfo = {}, questionnaireDetailsDTO = {}, questionnairePlanInfo = {} } } = await this.$fetch.fetchGetQuestionnaire({
        taskCode: code
      });
      const draft = localStorage.getItem(code)
      if (draft) {
        const questionList = JSON.parse(draft);
        questionList.forEach(question => {
          if (question.tempDate) {
            question.tempDate = new Date(question.tempDate);
          }
        })
        questionnaireDetailsDTO.questionList = questionList;
      } else {
        questionnaireDetailsDTO?.questionList?.forEach(question => {
          if (question.type === 8 && !question.answer) {
            question.answer = [];
          } else if (question.type === 4 && question.contentVerifyType === 1) {
            question.tempDate = new Date();
            question.showPicker = false;
          }
        })
      }
      
      this.patientInfo = patientInfo;
      this.questionnaireDetailsDTO = questionnaireDetailsDTO;
      this.questionnairePlanInfo = questionnairePlanInfo;
    },
    selectDate(val, question) {
      question.answer = window.util.parseDate(val, 'yyyy-MM-dd');
      question.showPicker = false;
    },
    afterRead(file) {
      this.uploadFile(file);
    },
    async uploadFile(fileRaw) {
      this.imgUploading = true;
      const raw = fileRaw;
      const { file } = raw;
      const formData = new FormData();
      formData.append('action', 'fileUpload');
      formData.append('file', file);
      try {
        raw.status = 'uploading';
        raw.message = '上传中...';
        const { data: { fileUrl } } = await this.$fetch.uploadFile(formData);
        raw.status = 'done';
        raw.url = fileUrl;
        console.log(fileUrl)
      } catch (e) {
        console.log(e);
        raw.status = 'failed';
        this.$toast('上传失败，请重试');
      } finally {
        this.imgUploading = false;
      }
    },
    // async uploadImg(params) {
    //   return await this.adapt.axios.post(`spider-fileupload/1.0/upload`, params, {
    //     headers: { 'Content-Type': 'multipart/form-data' }
    //   });
    // },
    async chooseImage(question) {
      if (question.answer && question.answer.length >= 6) {
        this.$toast('最多可上传6张照片');
        return;
      }
      try {
        // const { url } = await this.adapt.chooseSingleImage();
        var max = 6 - question.answer.length;
        Sailer.openCamera({ maxNumber: max }, function (res) {
          var data = res.data || {};
          if (data.urls && Array.isArray(data.urls)) {
            question.answer.push(...data.urls.map(url => ({url})));
          }
        });
      } catch (e) {
        console.log(e);
        this.$toast('照片上传失败');
      }
    },
    onSave() {
      const { businessCode } = this;
      console.log(this.questionList, JSON.parse(JSON.stringify(this.questionList)));
      localStorage.setItem(businessCode, JSON.stringify(this.questionList));
      this.answerChange = false;
      this.$toast('保存成功');
    },
    async submit() {
      const { businessCode, questionList, questionnairePlanInfo } = this;
      const questionAnswerList = [];
      for (var i = 0, len = questionList.length; i < len; i++) {
        const { questionRelationId, answer, isRequired, type } = questionList[i];
        if ((!answer || answer.length === 0)) {
          if (isRequired) {
            this.$toast('请您填写必填的信息');
            return;
          }
        } else {
          // 选择题
          if (type === 1 || type === 2) {
            let optionsResults = answer;
            if (!Array.isArray(answer)) {
              optionsResults = [answer];
            }
            optionsResults = optionsResults.map(v => ({
              optionsId: v
            }))
            questionAnswerList.push({
              questionRelationId,
              optionsResults
            })
          } else {
            let result = answer;
            if (type === 8) {
              result = answer.map(v => v.url).join(';');
            }
            questionAnswerList.push({
              questionRelationId,
              result
            })
          }
        }
      }
      const params = {
        taskCode: businessCode,
        commitQuestionnaireReqParam: {
          questionnaireId: questionnairePlanInfo.questionnaireId,
          userId: questionnairePlanInfo.userId,
          patientId: questionnairePlanInfo.patientId,
          questionAnswerList
        }
      }
      console.log(params);
      await this.$fetch.fetchPostQuestionnaireSubmit(params);
      this.$toast('提交成功');
      localStorage.removeItem(businessCode);
      this.$router.go(-1);
    },
    onBack() {
      if (!this.answerChange) {
        this.adapt.goBack()
      } else {
        this.$dialog
        .confirm({
          title: '温馨提示',
          message: '是否保存当前信息至草稿',
          cancelButtonText: '否',
          confirmButtonText: '是'
        })
        .then(() => {
          this.onSave();
          this.adapt.goBack();
        }).catch(() => {
          this.adapt.goBack();
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.page-questionnaire {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .app-upload {
    /deep/ .van-uploader__input-wrapper {
      > input {
        width: 0;
        height: 0;
      }
    }
  }
  .content {
    flex: 1 1 auto;
    overflow: auto;
    margin: 10px 0 10px;
    .header {
      padding: 12px 16px;
      background-color: #fff;
      margin-bottom: 10px;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #262626;
        line-height: 27px;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .desc {
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: #8C8C8C;
        line-height: 21px;
        margin: 8px 0 16px;
      }
      .patient-info {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        line-height: 16px;
        margin-top: 10px;
        .avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }
    .question-list {
      background-color: #fff;
      .question-title {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        line-height: 1.2;
        display: flex;
        margin-bottom: 20px;
        &.required::before {
          display: inline-block;
          content: '*';
          color: #FF4E47;
        }
      }
      .question-item {
        padding: 20px 20px 12px;
        .answer-area {
          margin: 0 8px;
          width: auto;
          .van-field {
            background: #f5f5f5;
          }
          .van-radio, .van-checkbox {
            border-radius: 4px;
            border: 1px solid #ECECEC;
            height: 46px;
            display: flex;
            align-items: center;
            padding: 0 15px;
            margin-bottom: 8px;
          }
          .icon-right {
            font-size: 24px;
            color: #bfbfbf;
            height: 20px;
          }
          .upload-preview-wrap {
            .upload-preview {
              position: relative;
              width: 78px;
              height: 78px;
              border: 1px dashed #d9d9d9;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
    }
  }
  .footer {
    flex: 0 0 auto;
    height: 52px;
    width: 100%;
    padding: 0 16px;
    display: flex;
    align-items: center;
    .van-button {
      width: 100%;
    }
  }
}
</style>
